module.exports = __webpack_public_path__ + "img/curtains.6e8ce4c0.svg";